/**
 * 관리자 설정 — 취급자 관리 (/adm/handlers?type=gps|ci)
 * ($j.Pages.Admin.Handlers / body data-page-name="Handlers")
 *
 * 위치정보·연계정보 취급자를 축별로 따로 보여준다(심사 캡처용) + 정기검토 기록.
 * 축·부서·역할 이름표는 컨트롤러가 #page-data 로 넘긴다.
 */
export default class Handlers {
    initialize() { initialize(); }
}

let $table = null;
let TYPE = 'gps', DEPARTMENT = {}, CI_LEVELS = {}, GPS_LEVELS = {};

function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    TYPE       = d.type;
    DEPARTMENT = d.departments || {};
    CI_LEVELS  = d.ciLevels || {};
    GPS_LEVELS = d.gpsLevels || {};

    initPage();
    $('#f-department').on('change', function(){ $table && $table.ajax.reload(); });
    $('#btn-review').on('click', onClickReview);
    // 지정일시 → 권한 변경이력 모달 (data-n 에 관리자 번호)
    $('#handler-table').on('click', 'a[data-grant-logs]', function(e){
        e.preventDefault();
        grantLogs(Number(this.dataset.grantLogs));
    });
}

// 정기검토 — 현재 축의 유효 취급자 전원에게 검토기록을 남긴다.
// 부서 필터와 무관하게 전원이 대상이다 (일부만 검토한 기록은 증빙이 되지 않는다).
function onClickReview(){
    $j.Ui.Dialog.prompt('취급자 검토 확인', {
        tone:        'info',
        desc:        '현재 취급자 전원을 검토한 것으로 기록합니다.',
        placeholder: '검토 의견 (선택)',
        confirm:     '기록',
        cancel:      '취소',
    }).then(function(memo){
        if (memo === null) return;   // 취소·닫기
        $.post('/adm/ajax/manager/handler/review', { type: TYPE, memo: memo || '' }, function(res){
            if (!res || !res.result) {
                $j.Ui.Dialog.open({ tone: 'danger', title: '기록 실패', desc: (res && res.message) || '' });
                return;
            }
            $j.Ui.Toast.show(`${res.count}명 검토기록 완료`, { type: 'success' });
            $table && $table.ajax.reload();
        });
    });
}

function deptBadge(d){
    const name = DEPARTMENT[d];
    return name ? `<span class="hd-dept hd-dept-${d}">${name}</span>` : '';
}

function initPage(){
    // 취급자 축에 따라 "역할" 칸이 보는 값이 달라진다 (위치정보=gps_level, 연계정보=ci_level)
    const roleColumn = (TYPE === 'gps')
        ? { data: null, title: '위치정보 역할', className: 'text-center',
            render: (d, t, r) => `<span class="hd-role hd-role-gps-${r.gps_level}">${GPS_LEVELS[r.gps_level] || ''}</span>`
          }
        : { data: null, title: '연계정보 역할', className: 'text-center',
            render: (d, t, r) => `<span class="hd-role hd-role-ci-${r.ci_level}">${CI_LEVELS[r.ci_level] || ''}</span>`
          };

    const columns = [
        { data: 'num', title: '번호', className: 'text-center' },
        { data: null, title: '부서', className: 'text-center', render: (d, t, r) => deptBadge(r.department) },
        { data: 'manage_name', title: '사용자' },
        { data: null, title: '계정',
            render: (d, t, r) => `<a href="/adm/managers" title="관리자 탭에서 수정">${r.manage_id || ''}</a>`
        },
        roleColumn,
        // 접근권한(레벨)은 역할과 별개 축이다 — 화면 권한선일 뿐, 법정역할이 아니다
        { data: null, title: '접근권한', className: 'text-center',
            render: (d, t, r) => `레벨 ${r.level}`
        },
        // 지정일시와 그 지정을 한 처리자. 변경·검토 내역은 이력 모달에서 본다
        { data: null, title: '지정일시', className: 'text-center',
            render: function (d, t, r) {
                if (!r.assigned_at) return '<span class="hd-none">-</span>';
                return `<a href="#" data-grant-logs="${r.num}" title="이력 보기">`
                     + `${dayjs(r.assigned_at).format('YYYY-MM-DD HH:mm')}</a>`;
            }
        },
        { data: null, title: '처리자', className: 'text-center',
            render: (d, t, r) => r.assign_handler || '<span class="hd-none">-</span>'
        },
    ];

    $table = new DataTable('#handler-table', {
        columns: columns,
        ajax: {
            url: '/adm/ajax/manager/handler/list',
            type: 'post',
            data: function (d) {
                d.type = TYPE;
                d.department = $('#f-department').val();
            },
            dataSrc: function (json) {
                drawReview(json.review);
                return json.data;
            },
        },
        processing: true,
        serverSide: false,
        ordering: false,
        displayLength: 30,
        lengthChange: false,
        searching: false,
        layout: { topStart: null, topEnd: null, bottomStart: 'info', bottomEnd: 'paging' },
        drawCallback: function () {
            const n = this.api().rows().count();
            $('#f-count').text(n);
            // 부서 필터가 없을 때의 건수가 곧 취급자 총원
            if (!$('#f-department').val()) $('#hd-total').text(n);
        },
    });
}

// 마지막 정기검토 한 줄 — 심사에서 "검토한 기록" 을 이 화면 캡처로 답할 수 있어야 한다
function drawReview(r){
    const $el = $('#hd-review');
    if (!r || !r.at) {
        $el.addClass('none').text('정기검토 기록 없음');
        return;
    }
    $el.removeClass('none').html(`최근 검토: <b>${dayjs(r.at).format('YYYY-MM-DD')}</b> (${r.count}명)`);
}

function grantLogs(n){
    $j.Ui.JBModal.open('jb-modal-grant-logs', '/adm/ajax/manager/grant-logs', { num: n }, { title: '권한 변경이력' });
}
